import React, { useState } from "react";
import toast from "react-hot-toast";
import { Form, Input } from "antd";
import ModalComponent from "../../../components/modals/ModalComponent";
import LoadableButton from "../../../components/button/LoadableButton";
import { ResetClientPasswordApi } from "../../../api/request/clients/clients";

const ResetPasswordModal = ({ client, isOpen, setIsOpen }) => {
  const [form] = Form.useForm();
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (values) => {
    setIsLoading(true);
    try {
      const params = { id: client?.id, new_password: values?.new_password };
      const { data } = await ResetClientPasswordApi(params);
      if (data?.status) {
        toast.success(data?.message);
        setIsOpen(false);
      }
    } catch (error) {
      if (error?.response?.data?.message)
        toast.error(error?.response?.data?.message);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <ModalComponent
      title="Reset Password"
      isOpen={isOpen}
      setIsOpen={setIsOpen}
    >
      <Form
        autoComplete="off"
        layout="vertical"
        form={form}
        onFinish={handleSubmit}
      >
        <Form.Item
          name="new_password"
          label="New Password"
          rules={[
            {
              required: true,
              message: "Please enter your new password!",
            },
            {
              pattern:
                /^(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*])[A-Za-z\d!@#$%^&*]{8,}$/,
              message: "Please enter strong password.",
            },
          ]}
        >
          <Input.Password placeholder="New password" size="large" />
        </Form.Item>

        <Form.Item
          name="confirm_password"
          label="Confirm Password"
          className="mb-0"
          rules={[
            {
              required: true,
              message: "Please enter your confirm password!",
            },
            ({ getFieldValue }) => ({
              validator(_, value) {
                if (!value || getFieldValue("new_password") === value) {
                  return Promise.resolve();
                }
                return Promise.reject(
                  new Error("The new password that you entered do not match!")
                );
              },
            }),
          ]}
        >
          <Input.Password placeholder="Confirm password" size="large" />
        </Form.Item>

        <div className="text-center mt-5">
          <LoadableButton
            type="submit"
            lable="Submit"
            loadingLable="Updating password..."
            isLoading={isLoading}
          />
        </div>
      </Form>
    </ModalComponent>
  );
};

export default ResetPasswordModal;
